var neo4j = require('neo4j')

var db = new neo4j.GraphDatabase(process.env.NEO4J.Connection)

export default {
  cypher (params) {
    return new Promise((resolve, reject) => {
      db.cypher(params, (err, result) => {
        if (err) {
          reject(err)
        } else {
          resolve(result)
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/neo4j.js